// @ts-nocheck
import React from "react";
import AddressesTable from "./AddressesTable";
import AdminOverview from "./dashboard/AdminOverview";
import CategoriesManager from "./CategoriesManager";
import CitiesManager from "./CitiesManager";
import OrdersTable from "./OrdersTable";
import PincodeManager from "./PincodeManager";
import SupportSettings from "./SupportSettings";
import UserRoleManager from "./UserRoleManager";
import Loader from "../common/Loader/Loader";
import { menuItems } from "../../utils/adminDashboard";

const AdminDashboardContent = ({
  activeTab,
  loading,
  error,
  categoriesProps,
  ordersProps,
  pincodeProps,
  citiesProps,
  addresses,
  admins,
  categories,
  cities,
  onUsersChanged,
  onSelectTab,
}) => {
  if (loading) {
    return (
      <section className="admin-card loading-card">
        <Loader size="lg" label="Loading admin data..." />
      </section>
    );
  }

  if (error) {
    return <section className="admin-card error-card">{error}</section>;
  }

  if (activeTab === "dashboard") {
    return (
      <AdminOverview
        orders={ordersProps.orders}
        categories={categories}
        admins={admins}
        addresses={addresses}
        cities={cities}
        onManageRates={() => onSelectTab("categories")}
      />
    );
  }

  if (activeTab === "categories" || activeTab === "price-management") {
    return <CategoriesManager {...categoriesProps} />;
  }

  if (activeTab === "orders") {
    return <OrdersTable {...ordersProps} />;
  }

  if (activeTab === "cities") {
    return <CitiesManager {...citiesProps} />;
  }

  if (activeTab === "pincodes") {
    return <PincodeManager {...pincodeProps} />;
  }

  if (activeTab === "addresses") {
    return (
      <AddressesTable
        addresses={addresses}
        orders={ordersProps.orders}
        currentAdminId={ordersProps.currentAdminId}
      />
    );
  }

  if (activeTab === "support" || activeTab === "settings") {
    return <SupportSettings />;
  }

  if (activeTab === "field-executives") {
    return <UserRoleManager onUsersChanged={onUsersChanged} />;
  }

  return (
    <section className="admin-card empty-panel">
      <h2>{menuItems.find((item) => item.key === activeTab)?.label}</h2>
      <p>This section is ready for backend data.</p>
    </section>
  );
};

export default AdminDashboardContent;
